import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { SpinnerService } from './spinner.service';
import { SESSION_STORAGE_CURRENT_COMPANY_KEY } from 'src/app/shared/constants/session-storage-keys';
import { isImportacionRequest } from '../config/importacion.config';
import { SKIP_GLOBAL_SPINNER } from './http-error-context';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
	constructor(
		private authService: AuthService,
		private spinnerService: SpinnerService
	) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		if (
			request.url.includes(environment.apiUrl) ||
			request.url.includes(environment.apiUrlTrazabilidad) ||
			request.url.includes(environment.apiUrlFuentesInformacion) ||
			isImportacionRequest(request.url)
		) {
			const skipSpinner =
				request.context.get(SKIP_GLOBAL_SPINNER) ||
				request.headers.has('X-Skip-Spinner') ||
				request.url.includes('/Embarques/Reporte/Estado/');
			if (!skipSpinner) {
				this.spinnerService.show();
			}
			return next.handle(this.setAuthorizationHeader(request)).pipe(
				finalize(() => {
					if (!skipSpinner) {
						this.spinnerService.hide();
					}
				})
			);
		}

		return next.handle(request);
	}

	private setAuthorizationHeader(
		request: HttpRequest<unknown>
	): HttpRequest<unknown> {
		const idEmpresa =
			sessionStorage.getItem(SESSION_STORAGE_CURRENT_COMPANY_KEY) != null
				? sessionStorage.getItem(SESSION_STORAGE_CURRENT_COMPANY_KEY)
				: '';
		const requestWithAuthorization: HttpRequest<unknown> = request.clone({
			setHeaders: this.buildHeaders(request, idEmpresa!.toString())
		});

		return requestWithAuthorization;
	}

	private buildHeaders(
		request: HttpRequest<unknown>,
		idEmpresa: string
	): Record<string, string> {
		const headers: Record<string, string> = {
			'current-company': idEmpresa,
			[environment.apimSubscriptionKey]: environment.apimSubscriptionValue
		};

		if (
			!request.url.includes('/RegistroProductor/contexto') &&
			!request.url.includes('/RegistroProductor/confirmar')
		) {
			headers['Authorization'] = `Bearer ${this.authService.getAccessToken()}`;
		}

		return headers;
	}
}
